import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-brisanje',
  templateUrl: './brisanje.component.html',
  styleUrls: ['./brisanje.component.css']
})
export class BrisanjeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
